function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Autofarm",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1509 6.66106H17.3648V8.14519H14.2642V12.5976C14.2642 12.5976 14.3145 14.9999 14.2642 17.1129C14.2138 19.2259 12.5535 21.2609 10.1761 21.2609C7.79875 21.2609 6 19.5278 6 17.1129C6.00002 14.698 7.93711 13.0126 10.1258 13.0126C11.6981 13.0126 12.4654 13.7421 12.4654 13.7421V8.14519H11.283V6.66106H12.4654V5.66744C12.4654 3.47898 14.4906 2.53568 15.3836 2.48537C16.2013 2.4125 17.1824 2.38403 18 2.58598V4.21677C16.9004 3.85798 16.5357 3.89325 16.014 3.94371C15.9688 3.94808 15.9224 3.95257 15.8742 3.95693C15.1824 4.01947 14.1509 4.76187 14.1509 5.7555V6.66106ZM12.6069 17.0484C12.6069 18.3821 11.5257 19.4633 10.1919 19.4633C8.85805 19.4633 7.77678 18.3821 7.77678 17.0484C7.77678 15.7147 8.85805 14.6336 10.1919 14.6336C11.5257 14.6336 12.6069 15.7147 12.6069 17.0484Z",
  fill: "none"
}));

var SvgAutoFarm = function SvgAutoFarm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAutoFarm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/auto_farm.09ae772a.svg";
export { ForwardRef as ReactComponent };